import { render, staticRenderFns } from "./StoreTemplateDetails.vue?vue&type=template&id=46219d3b&scoped=true&"
import script from "./StoreTemplateDetails.vue?vue&type=script&lang=ts&"
export * from "./StoreTemplateDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46219d3b",
  null
  
)

export default component.exports